import {get} from 'lodash';

export default (state = {}, {candidateId, data}: any) => {
  return {
    ...state,
    allCandidates: {
      ...get(state, 'allCandidates', {}),
      [candidateId]: data,
    },
  };
};
